<template>
  <nav>
    <el-row
      align="middle"
      type="flex"
      class="bg-row"
      justify="space-between"
    >
      <!-- Fixed content -->
      <el-col class="lefter">
        <AsideToggler class="nav__toggler"/>
        <div class="nav__header">
          <h1>
            {{ heading }}
          </h1>
        </div>
      </el-col>
      <el-col style="flex-shrink: 2; text-align: right;">
        <ProfilePopover/>
      </el-col>

    
    </el-row>
  </nav>
</template>

<script>
import ProfilePopover from './ProfileDropdown';
import AsideToggler from '../Aside/AsideToggler';

export default {
  components: {
    ProfilePopover,
    AsideToggler,
  },
  computed: {
    heading() {
      return this.$route.path.split('/')[1];
    },
  },
};
</script>

<style lang="scss">
.navigation {
  box-shadow: 1px 1px 1px 1px rgba(0,0,0,0.1);
  z-index: 1;
  background-color: white;
  color: black;
  position: relative;
}

.navigation {
  .lefter {
    white-space: nowrap;
    > * {
      vertical-align: middle;
      display: inline-block;
    }
  }
}

nav {
  height: 100%;
  > * {
    height: 100%;
  }

  .nav__header {
    font-size: 0.8em;
    h1 {
      margin: 0;
      text-transform: capitalize;
    }
  }
  .nav__toggler {
    margin-left: -20px;
    margin-right: -5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation/index.vue